import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { useSearchParams } from '../../hooks/useSearchParams';
import { LISTINGS_PER_PAGE } from '../constants';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultsPaginator() {
  var _data$result$total;
  const params = useSearchParams();
  const {
    data
  } = useSearchResultsQuery();
  if (!data) return undefined;
  const queryType = params.get('queryType');

  // Show pagination when queryType is not present or is ELASTIC_SEARCH
  if (queryType && queryType !== 'ELASTIC_SEARCH') return undefined;
  const currentPage = Number(params.get('page')) || 1;
  const totalResults = (_data$result$total = data.result.total) !== null && _data$result$total !== void 0 ? _data$result$total : 0;
  const pageCount = Math.max(1, Math.ceil(totalResults / LISTINGS_PER_PAGE));
  return /*#__PURE__*/_jsx(Paginator, {
    marginBlockStart: "800",
    pageCount: pageCount,
    page: currentPage,
    onPageChange: e => {
      params.set('page', e.target.value.toString());
      window.scrollTo(0, 0);
    }
  });
}